import script from "./CrossCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CrossCard.vue?vue&type=script&setup=true&lang=js"

import "./CrossCard.vue?vue&type=style&index=0&id=f7845d50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7845d50"]])

export default __exports__